var map = {
	"./bulgartabac_b.svg": 2114,
	"./bulgartabac_logo_large.svg": 1986,
	"./bulgartabac_logo_long.svg": 5413,
	"./corporate-profile.jpeg": 8951,
	"./home-hero-img-test.jpeg": 1916,
	"./img_about_1.jpeg": 2827,
	"./investor-center.jpeg": 6087,
	"./sofia-b.png": 532,
	"./tmp_img.jpeg": 8526,
	"./yweb-dev-logo-sm.svg": 1129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;